import ReceiptBlock from './ReceiptBlock';
export * from './ReceiptBlock';

export default ReceiptBlock;
